module.exports = "http://cdn.realive.com.ua/src/views/casino/jacpot/logo.svg";